module.exports = __webpack_public_path__ + "img/35.11b4f654.png";